<template>
        <router-view></router-view>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: "Reports",
    props: { report: String, id: String, prop1: String, prop2: String },
    components: {},
    data () { return {}; },
    computed: {
        ...mapState(['currentUser', 'account'])
    }
};
</script>
